<template>
  <div class="login">
    <div class="login__container">
      <div class="login__title">{{ $t('labels.invitation_form_title') }}</div>
      <div class="login__text text-capitalize-first">{{ $t('labels.invite_set_password') }}</div>
      <form class="login__form"  v-if="invite">
        <input type="text" class="form-control login__input user-icon" v-model="invite!.user.email" readonly :placeholder="$t('labels.login')">
        <FormInputWrapper v-slot="parentProps" :errors="getErrors(`password`)" class="w-100">
        <input :class="parentProps.class" type="password"  id="password"
               name="password" class="form-control login__input password-icon" v-model="request.password" :placeholder="$t('labels.password')">
        </FormInputWrapper>
        <FormInputWrapper v-slot="parentProps" :errors="getErrors(`passwordConfirm`)" class="w-100">
        <input :class="parentProps.class" type="password" id="password_confirm"
               name="password_confirm" class="form-control login__input password-icon" v-model="request.passwordConfirm" :placeholder="$t('labels.confirm_password')">
        </FormInputWrapper>
        <LoaderButton type="button"  class="btn btn--accept text-capitalize-first" :on-click="save"><span class=" text-capitalize-first">{{ $t('button.create_account') }}</span></LoaderButton>
      </form>
    </div>
  </div>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, toRefs, reactive, ref, ComputedRef, computed} from 'vue'
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import {useStore} from "vuex";
import {$t, helper} from "@/service/CommonHelper";
import {useNotification} from "@kyvg/vue3-notification";
import {useRoute} from "vue-router";
import InviteRequestDTO from "@/models/InviteRequestDTO";
import InviteRequestUserRequestDTO from "@/models/request/InviteRequestUserRequestDTO";
import FormInputWrapper from "@/components/FormInputWrapper.vue";
import ValidationErrorDTO from "@/models/ValidationErrorDTO";
import router from "@/router";
import LoaderContent from "@/apps/public/components/LoaderContent.vue";
import LoaderButton from "@/apps/public/components/LoaderButton.vue";
import {api} from "@/service/APIClient";
const notification = useNotification()

const redirectTo = (role: any) => {
  switch (role) {
    default:
      return '/';
  }
}

export default defineComponent({
  methods: {$t},
  components: {
    LoaderButton,
    LoaderContent,
    LoaderWrapper,
    FormInputWrapper
  },
  setup() {
    const route = useRoute()
    const store = useStore()

    const state = reactive({
      lang: window.userLang,
      invite: null as InviteRequestDTO|null,
      request: {
        password: "",
        passwordConfirm: ""
      } as InviteRequestUserRequestDTO,
      errors: {} as ValidationErrorDTO[]|any,
    });

    const changeLang = (lang: string) => {
      helper.setLang(lang)
      state.lang = lang
    }

    onMounted(async () => {
      if (route.params.token) {
        try {
          state.invite = await api.getInviteRequest(route.params.token as string)
        } catch (e) {
          notification.notify({title: "not found or expired"})
          setTimeout(() => {
            window.location.href = "/";
          }, 1000)
        }

      }
    });

    const setErrors = (data: ValidationErrorDTO[]) => {
      state.errors = {};
      for (const error of data) {
        if (!state.errors.hasOwnProperty(error.field)) {
          state.errors[error.field] = [];
        }
        state.errors[error.field].push(error)
      }
    }

    const save = async () => {
      state.errors = [];
      try {
        state.request.lang = window.userLang
        const accessToken = await api.useInviteRequest(state.invite!.token, state.request)
        await store.dispatch('useAccessToken', accessToken);
        await store.dispatch('loadUser');
        window.location.href = redirectTo(store.getters["getRole"]);
      } catch (e: any) {
        if (e.response && e.request && e.request.status === 400 && e.response.data) {
          setErrors(e.response.data)
        } else {
          console.log(e);
        }
      }
    }

    const getErrors = (path: string) => {
      if (!state.errors.hasOwnProperty(path)) {
        return [];
      }

      return state.errors[path]
    }

    return {
      ...toRefs(state),
      getErrors,
      changeLang,
      save,
      dateHelper,
      numberFormatter,
      helper,
    }
  }
})
</script>
